<template>
	<app-page>
		<app-heading :title="isNew ? 'New Asset' : asset.filename" />
		<app-form @submit="onSubmit">
			<app-section style="width: 500px;" class="mt-4 website-asset-section">
				<app-section-actions>
					<app-button type="submit" small color="success" v-if="isNew">Create</app-button>
					<app-button type="submit" small color="primary" v-else>Save</app-button>
					<app-button type="cancel" small :to="{ name: 'website-assets', query: { directory: parent } }">Cancel</app-button>
				</app-section-actions>
				<input-text
					label="Name"
					v-model="asset.filename"
					required
					:errors="errors.filename"
					hint="Name on CDN without the extension"
				/>
				<input-file
					v-if="!isDirectory"
					type="all"
					label="Asset"
					@load="onImport"
				/>
			</app-section>
		</app-form>
	</app-page>
</template>

<script>
export default {
	async created() {
		this.$store.dispatch('app/startLoading')
		try {
			if (this.id !== 'new') {
				const asset = await this.$ravello.request()
					.v(2)
					.to('websites')
					.to(this.websiteId)
					.to('assets')
					.to(this.id)
					.get()

				this.asset.filename = asset.filename
			}
		} catch (err) {
			this.$notifications.pushAlert('error', err.data ? err.data.message : err.message)
		}
		this.$store.dispatch('app/stopLoading')
	},
	data() {
		return {
			asset: {
				filename: '',
				asset: null,
			},
			errors: {},
		}
	},
	computed: {
		websiteId() {
			return this.$route.params.website
		},
		id() {
			return this.$route.params.asset
		},
		parent() {
			return this.$route.query.parent
		},
		isNew() {
			return this.id === 'new'
		},
		isDirectory() {
			return !!this.$route.query.directory
		},
	},
	methods: {
		onImport(data) {
			this.asset.asset = data
		},
		async onSubmit() {
			this.$store.dispatch('app/startLoading')
			try {
				if (this.isNew) {
					await this.$ravello.request()
						.v(2)
						.to('websites')
						.to(this.websiteId)
						.to('assets')
						.create({
							filename: this.asset.filename,
							...(!this.isDirectory ? { asset: this.asset.asset } : {}),
							...(this.parent ? { parent: this.parent } : {}),
							directory: this.isDirectory,
						})
				} else {
					await this.$ravello.request()
						.v(2)
						.to('websites')
						.to(this.websiteId)
						.to('assets')
						.to(this.id)
						.update({
							filename: this.asset.filename,
							...(this.asset.asset ? { asset: this.asset.asset } : {}),
						})
				}
				this.$store.dispatch('app/stopLoading')
				this.$notifications.pushAlert('success', `Asset successfully ${this.isNew ? 'added' : 'updated'}`)
				this.$router.push({ name: 'website-assets', query: { directory: this.parent } })
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
				if (err.status === 400) {
					this.errors = err.data.details || {}
				}
				this.$store.dispatch('app/stopLoading')
			}
		},
	},
}
</script>
